/* =========================================================
   Cuándo se actualizó una ficha: fecha Y hora.

   La hora la sella el servidor en cada guardado (last_updated_at) y llega
   en ISO, en UTC. Aquí se enseña en la hora local de quien mira: una
   ficha guardada a las 15:42 en Guatemala dice 15:42 en Guatemala, no
   21:42.

   Las fichas que nunca se editaron desde el portal solo tienen el día
   —vino del padrón, sin hora—, y entonces se enseña solo el día en vez
   de inventar una medianoche.
   ========================================================= */

interface ConFecha {
  LastUpdated?: string;
  LastUpdatedAt?: string;
}

/** «29 sep 2026, 15:42» · «29 sep 2026» · ''. */
export function fechaHoraActualizacion(r: ConFecha | undefined, lang: 'es' | 'en'): string {
  if (!r) return '';
  const locale = lang === 'es' ? 'es-GT' : 'en-US';
  if (r.LastUpdatedAt) {
    const d = new Date(r.LastUpdatedAt);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' });
    }
  }
  if (r.LastUpdated) {
    // 'yyyy-mm-dd' a mediodía: interpretado a medianoche UTC saldría el día
    // anterior en toda América
    const d = new Date(`${r.LastUpdated}T12:00:00`);
    if (!Number.isNaN(d.getTime())) return d.toLocaleDateString(locale, { dateStyle: 'medium' });
    return r.LastUpdated;
  }
  return '';
}

/** Para ordenar y exportar: «2026-09-29 15:42» en hora local, o el día. */
export function fechaHoraOrdenable(r: ConFecha | undefined): string {
  if (!r) return '';
  if (r.LastUpdatedAt) {
    const d = new Date(r.LastUpdatedAt);
    if (!Number.isNaN(d.getTime())) {
      const p = (n: number) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} `
        + `${p(d.getHours())}:${p(d.getMinutes())}`;
    }
  }
  return r.LastUpdated ?? '';
}

/** La línea de la cabecera: «Actualizado: 29 sep 2026, 15:42». */
export function lineaActualizado(r: ConFecha | undefined, lang: 'es' | 'en'): string {
  const f = fechaHoraActualizacion(r, lang);
  if (!f) return '';
  return lang === 'es' ? `Actualizado: ${f}` : `Updated: ${f}`;
}
